import React from 'react';
import ReactDOM from 'react-dom/client'; // Using the new React 18 API
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from 'react-router-dom'; // Import BrowserRouter
import { WorkshopProvider } from './WorkshopContext';

const root = ReactDOM.createRoot(document.getElementById('root'));
const basename = process.env.NODE_ENV === "development" ? "/" : "/benchmarks/stakeholder-insights-explorer";

root.render(
  <React.StrictMode>
    <BrowserRouter basename={basename}>
      <WorkshopProvider>
        <App />
      </WorkshopProvider>,
    </BrowserRouter>
  </React.StrictMode>
);

// Optional: reportWebVitals usage for performance measurements
reportWebVitals();
